namespace Pages {
    export class SettingsPage {
        private readonly _repository: RavenDbClient;

        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }
        async index() {
            var settings = await Stores.SettingsStore.get(this._repository);
            return new PageViewResult("Settings/", settings);
        }

        async update({ id, model }: { id: string, model: Entities.Settings }) {
            await Stores.SettingsStore.set(this._repository);
            return new PageActionResult(
                new PageActionReload()
            );
        }
    }
}